<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_detail') === -1 &&
        $route.path.indexOf('_edit') === -1
      "
    >
      <el-row :gutter="24">
        <el-col :span="3">
          <el-input
            placeholder="店铺编号"
            v-model="params.sub_unit_num_id"
            style="width: 100%"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="third_name_value" placeholder="请选择" @change="thirdNameChange">
            <el-option
                    v-for="item in third_name"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" @click="init"
            >重置</el-button
          >
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="searchData"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <div class="content-bottom-padded">
        <el-alert
          type="success"
          title="以下颜色代表资质证书到期时间"
          show-icon
          >
            <div>
              深黑：长期有效（1年以上），灰色：已过期，红色：小于30天，蓝色：30天--60天，绿色：60天--1年
            </div>
        </el-alert>
      </div>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column
          prop="sub_unit_num_id"
          label="店铺编号"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="sub_unit_name"
          label="店铺名称"
          width="220"
        ></el-table-column>
        <el-table-column
        prop="business_scope"
        label="法人"
        width="100"
      ></el-table-column>>
        <el-table-column
          prop="store_head_leader"
          label="企业负责人"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="quality_leader"
          label="质量负责人"
          width="100"
        ></el-table-column>
        <!-- <el-table-column
          prop="address"
          label="到期提醒"

        ></el-table-column> -->
        <el-table-column  prop="tagList" label="证照到期时间">
          <template slot-scope="scope">
            <el-tag v-for="taglist in scope.row.tagList" :key="taglist.index" :color="taglist.tag_color" size="mini" :style="'color:'+ taglist.font_color" style="display: inline-block; margin-right:3px;">{{taglist.tag_name}}</el-tag>
          </template>
        </el-table-column>
         <el-table-column
          prop="address"
          label="营业场所"

        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <!-- <el-tag size="" effect="plain" @click="edit(scope.row)"
              >☞资质详情☞</el-tag
            > -->
            <router-link :to="{ path: matchHidePage('detail'), query: { sub_unit_num_id: scope.row.sub_unit_num_id}}"> <span> ☞资质详情☞</span></router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :total="total_count"
          :page-size="params.pagesize"
        >
        </el-pagination>
      </div>
      <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
import {getQualificationBasic} from "../../api/qualification";
export default {
   components: { imgPicker, draggable },
  data() {
    return {
      pickerImgType: "",
      imgDialog: false,
      isGetImage: false,
      dialogFormVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
        status:1
      },
      form: {
        item_num_id: "",
        item_name: "",
        approval_no: "",
        approval_url: "",
        approval_begin_date:"",
        approval_end_date:""
      },
      dataList: [],
      loading: false,
      id: "",
      third_name: [{
            value: '1',
            label: '长期有效',
        }, {
            value: '2',
            label: '已过期',
            // disabled:true,
        },{
          value: '3',
          label: '30天内',
          // disabled:true,
        },{
          value: '4',
          label: '30天-60天',
          // disabled:true,
        },{
          value: '5',
          label: '60天-1年',
          // disabled:true,
        },
      ],
      third_name_value:'',
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    toAdd() {
      this.form=[];
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList()
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList();
      this.form= row;
      this.id = row.id;
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCredentials(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      console.log(this.params,'11111111111111111');
      getQualificationBasic(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
     pickImg(data) {
      this.form[this.pickerImgType] = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
    thirdNameChange(val){
      this.params.type = this.third_name_value
      this.getDataList(this.params)
    },
    init(){
      this.third_name_value = ''
      this.params.type = ''
      this.getDataList(this.params)
    }
  },
  mounted() {
    this.params.type = '';
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?b17b9576